/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDName } from './IDName';
import {
    IDNameFromJSON,
    IDNameFromJSONTyped,
    IDNameToJSON,
    IDNameToJSONTyped,
} from './IDName';
import type { Branch } from './Branch';
import {
    BranchFromJSON,
    BranchFromJSONTyped,
    BranchToJSON,
    BranchToJSONTyped,
} from './Branch';

/**
 * 
 * @export
 * @interface Order
 */
export interface Order {
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    reference?: number;
    /**
     * 
     * @type {Branch}
     * @memberof Order
     */
    branch: Branch;
    /**
     * 
     * @type {Date}
     * @memberof Order
     */
    opened_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof Order
     */
    closed_at: Date;
    /**
     * 
     * @type {IDName}
     * @memberof Order
     */
    order_type: IDName;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    gross_sales: number;
}

/**
 * Check if a given object implements the Order interface.
 */
export function instanceOfOrder(value: object): value is Order {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('branch' in value) || value['branch'] === undefined) return false;
    if (!('opened_at' in value) || value['opened_at'] === undefined) return false;
    if (!('closed_at' in value) || value['closed_at'] === undefined) return false;
    if (!('order_type' in value) || value['order_type'] === undefined) return false;
    if (!('gross_sales' in value) || value['gross_sales'] === undefined) return false;
    return true;
}

export function OrderFromJSON(json: any): Order {
    return OrderFromJSONTyped(json, false);
}

export function OrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): Order {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'reference': json['reference'] == null ? undefined : json['reference'],
        'branch': BranchFromJSON(json['branch']),
        'opened_at': (new Date(json['opened_at'])),
        'closed_at': (new Date(json['closed_at'])),
        'order_type': IDNameFromJSON(json['order_type']),
        'gross_sales': json['gross_sales'],
    };
}

export function OrderToJSON(json: any): Order {
    return OrderToJSONTyped(json, false);
}

export function OrderToJSONTyped(value?: Order | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'reference': value['reference'],
        'branch': BranchToJSON(value['branch']),
        'opened_at': ((value['opened_at']).toISOString()),
        'closed_at': ((value['closed_at']).toISOString()),
        'order_type': IDNameToJSON(value['order_type']),
        'gross_sales': value['gross_sales'],
    };
}

